import preval from 'preval.macro';
import PropTypes from 'prop-types';
import React from 'react';
import { withApollo } from 'react-apollo';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import { LayoutContent } from 'lixani-lib-ui';
import RecordDialogContainer from 'scenes/WorkDemo/components/RecordDialog/RecordDialogContainer';
import AppBar from './components/AppBar';

const buildTime = preval`
	const moment = require('moment')
	module.exports = moment(new Date()).format('DDMMYY-HHmm');
`;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    zIndex: 1,
  },
  footer: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

function Layout(props) {
  const classes = useStyles();
  const { t } = useTranslation('common');

  const { children, client } = props;
  return (
    <div className={classes.root}>
      <RecordDialogContainer />
      <AppBar client={client} />
      <LayoutContent
        marginTop={77}
        footerClass={classes.footer}
        footerText={t('footer.powered_by') + ' (v. ' + buildTime + ')'}
        layoutStyle={{ backgroundColor: 'initial' }}
      >
        {/*<div style={{"maxWidth":1024,"margin":"auto"}}>*/}
        {children}
        {/*</div>*/}
      </LayoutContent>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
  client: PropTypes.object.isRequired,
};

const LayoutWithApollo = withApollo(Layout);

export default LayoutWithApollo;
